import React, { useEffect } from "react";
import { Card, CardBody, Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

type OfflinePlaceholderProps = {
  title: string;
  message: string;
};

const OfflinePlaceholder: React.FC<OfflinePlaceholderProps> = ({ title, message }) => {
  useEffect(() => {
    document.title = `${title} | Saas`;
  }, [title]);

  return (
    <div className="page-content">
      <Container fluid className="px-2 px-md-3">
        <BreadCrumb title={title} pageTitle="Informes" />
        <Card className="border-0 shadow-sm">
          <CardBody className="text-center py-5">
            <div className="mx-auto" style={{ maxWidth: 520 }}>
              <h5 className="text-body fw-semibold mb-2">Contenido no disponible</h5>
              <p className="text-muted mb-0">{message}</p>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export const StockInventariosOfflinePage = () => (
  <OfflinePlaceholder
    title="Stock - Inventarios (Offline)"
    message="Estamos preparando esta vista offline. Mientras tanto podés consultar los informes en la sección Online."
  />
);

export const StockTransferenciasOfflinePage = () => (
  <OfflinePlaceholder
    title="Stock - Transferencias (Offline)"
    message="Pronto podrás revisar las transferencias en modo offline desde aquí. Por ahora solo está disponible el informe online."
  />
);

export const StockComprasOfflinePage = () => (
  <OfflinePlaceholder
    title="Stock - Compras (Offline)"
    message="Estamos trabajando en la versión offline de este informe. Consultalo desde la sección Online por el momento."
  />
);
